module.exports = __webpack_public_path__ + "img/software-thumb-1.3fdd9926.png";